export default "__VITE_ASSET__77bcb53c__"